import React from "react";
import "./Login.css";
import Header from "../Components/Header";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom"; //Link

export default function Register() {
  return (
    <>
      <Header mode="dark" />
        <div className="container-fluid">
      <div className="login-wrapper d-flex align-items-center justify-content-center">
        <form className="login-card text-center">
          <h3 className="login-title">Create an account</h3>

          <input
            type="text"
            className="form-control login-input"
            placeholder="Full Name"
          />

          <input
            type="number"
            className="form-control login-input"
            placeholder="Phone Number"
          />

           <input
            type="email"
            className="form-control login-input"
            placeholder="Email Address"
          />

           <input
            type="text"
            className="form-control login-input"
            placeholder="Password"
          />

           <input
            type="text"
            className="form-control login-input"
            placeholder="Confirm Password"
          />

 
          <div className="d-flex justify-content-between align-items-center login-options">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" />
              <label className="form-check-label">By signing up you agree to our terms and conditions.</label>
            </div>

           
          </div>

          <button className="btn login-btn w-100">
            <Link to="/dashboard">
            Create Account
            </Link>
            </button>

          <p className="register-text">Already have an account?</p>

         
          <Link to="/login">
           <p className="register-link">Log In</p>
        </Link>
        </form>
      </div>
      </div>
      <Feature />
      <Footer />
    </>
  );
}
